import React from "react";
import { useEffect } from "react";
import { useGlobal } from "@/context/GlobalContext";
import { useNavigate, useLocation } from "react-router-dom";

const LeftOffRedirector: React.FC = () =>
{
    const navigate = useNavigate();
    const location = useLocation();

    const { getFirstUncompletedPage, setFirstUncompletedPage, godMode } = useGlobal();

    const destination = getFirstUncompletedPage();

    var currentUrl = location.pathname;

    useEffect(() =>
    {
        if (godMode) return;

        if (currentUrl !== "/dashboard")
        {
            setFirstUncompletedPage(null);
            return;
        }

        if (destination === null || destination === "[finished]")
        {
            return;
        }

        // On login/dashboard entry we only force the user into the Personal Profile
        // flow when it is still incomplete. Every other workflow page (Housing,
        // Financial, etc.) resumes at its first uncompleted step only when the user
        // navigates to it via a dashboard tile — not automatically on login.
        if (!destination.startsWith("/dashboard/profile"))
        {
            setFirstUncompletedPage(null);
            return;
        }

        // Land the user on the Personal Profile page but do NOT pin a specific
        // ?step=. The server's workflow-level page list does not track every
        // ProfilePage panel (e.g. Student Details), so pinning its step here would
        // override ProfilePage's own, finer-grained "continue from last panel"
        // resume. Strip any query string and let ProfilePage resolve the first
        // uncompleted step itself.
        const profilePath = destination.split("?")[0];
        navigate(profilePath);
    }, [currentUrl, setFirstUncompletedPage, navigate, destination, godMode])

    return <></>;
};

export default LeftOffRedirector;